import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_material_request = async (request) => {
    try {
        const data = {
            date: request?.date,
            site: request?.site,
            requested_by: request?.requested_by,
            priority: request?.priority,
            notes: request?.notes,
            request_status: request?.request_status,
            details: request?.details,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/create-material-request`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const update_material_request = async (request) => {
    try {
        const data = {
            id: request?.id,
            date: request?.date,
            site: request?.site,
            requested_by: request?.requested_by,
            priority: request?.priority,
            notes: request?.notes,
            request_status: request?.request_status,
            details: request?.details,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/update-material-request`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const delete_material_request = async (request) => {
    try {
        const data = {
            id: request?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/delete-material-request`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_material_request = async (request) => {
    try {
        const data = {
            id: request?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-material-request`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_all_material_requests = async (request) => {
    try {
        const data = {
            search: request?.search,
            sort: request?.sort,
            status: request?.status,
            request_status: request?.request_status,
            priority: request?.priority,
            page: request?.page,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-all-material-requests`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

export {
    create_material_request,
    update_material_request,
    delete_material_request,
    get_material_request,
    get_all_material_requests,
};